import React from 'react';
import { Box } from '../../../Box';
import { Typography, TypographyVariant } from '../../../Typography';
import { StyledTableRowRelativePosition } from './styled';
export var NoDataMessage = function NoDataMessage(_ref) {
  var message = _ref.message;
  return /*#__PURE__*/React.createElement(StyledTableRowRelativePosition, null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Box, {
    pt: "m",
    position: "absolute",
    left: "0",
    right: "0"
  }, ['string', 'undefined'].indexOf(typeof message) >= 0 ? /*#__PURE__*/React.createElement(Typography, {
    textAlign: "center",
    variant: TypographyVariant.BODY
  }, message || 'No records available for this category or filter criteria') : message)));
};